import { gql } from '@apollo/client';

import { assessmentDetailsFragment } from 'approot/assessment/sections/details/details.graphql';
import { lessonDetailsFragment } from 'approot/lesson/sections/details/details.graphql';

const recentlyViewedContentFragment = gql`
  fragment RecentlyViewedContentFragment on RecentVisitedContentInformation {
    id
    recentContent {
      lessonNumber
      visitedFromUnitId
      lastViewedSectionId
      content {
        ... on Lesson {
          slug
          archivedAt
          ...LessonDetailsFragment
          squareImage {
            responsive {
              width
              height
              urls {
                url
                quality
              }
            }
          }
          lessonActivities {
            id
            status
            language
            version
          }
          outcomes {
            curriculum
          }
        }
        ... on Assessment {
          slug
          archivedAt
          ...AssessmentDetailsFragment
          squareImage {
            responsive {
              width
              height
              urls {
                url
                quality
              }
            }
          }
          assessmentActivities {
            id
            status
            version
            language
            isAutomarkable
          }
          outcomes {
            curriculum
          }
        }
      }
    }
  }
  ${lessonDetailsFragment}
  ${assessmentDetailsFragment}
`;

export const GET_RECENTLY_VIEWED_CONTENT = gql`
  query GetRecentlyViewedContent($input: GetRecentlyViewedContentInput!) {
    getRecentlyViewedContent(input: $input) {
      ...RecentlyViewedContentFragment
    }
  }
  ${recentlyViewedContentFragment}
`;

export const SET_RECENTLY_VIEWED_CONTENT = gql`
  mutation SetRecentlyViewedContent($input: SetRecentlyViewedContentInput!) {
    setRecentlyViewedContent(input: $input) {
      ...RecentlyViewedContentFragment
    }
  }
  ${recentlyViewedContentFragment}
`;
